/**
 * Created by cz on 2020/4/24.
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  state: {
    dialogVisible: false
  },
  mutations: {
    showDialog (state) {
      state.dialogVisible = true
    },
    hideDialog (state) {
      state.dialogVisible = false
    }
  },
  actions: {},
  getters: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js